/**
 * @generated SignedSource<<e7986b10cf5eb1af2baa13e26bf7aa27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type PipelineRunPageJobAgentCompatibilityStatusFragment$data = {
  readonly attributes: {
    readonly entry: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly value: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly id: number | null | undefined;
  readonly state: BuildState | null | undefined;
  readonly waitReason: string | null | undefined;
  readonly " $fragmentType": "PipelineRunPageJobAgentCompatibilityStatusFragment";
};
export type PipelineRunPageJobAgentCompatibilityStatusFragment$key = {
  readonly " $data"?: PipelineRunPageJobAgentCompatibilityStatusFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineRunPageJobAgentCompatibilityStatusFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineRunPageJobAgentCompatibilityStatusFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "waitReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "locator",
          "value": "name:teamcity.pipeline.job.id"
        }
      ],
      "concreteType": "Entries",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Entry",
          "kind": "LinkedField",
          "name": "entry",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "attributes(locator:\"name:teamcity.pipeline.job.id\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "e5f08c7a4aca4a05e0a3e54f2cb22dbc";

export default node;
